module.exports = window.sharedLibraries["nushop"]["prop-types"];